import '../css/global.css';
import $ from 'jquery';
import '@fortawesome/fontawesome-free';
import 'bootstrap';
import 'nouislider';
import 'owl.carousel';
import 'select2';
import 'select2/dist/js/i18n/it.js';
import 'lazysizes';
import toastr from 'toastr';
import {
  CustomSwal
} from './utils';
import {
  sendGtagConfig
} from './analytics';

import './number';
import './main';
import './slideshow';

import './vue-components/vue-components.js';
import trans from './i18n';
import { trackFormSubmit } from './tag-manager/gtm';
import Swal from "sweetalert2";
import Swiper from "swiper";
import { Navigation, Pagination } from 'swiper/modules';

let slideInterval;

jQuery(document).ready(() => {
  jQuery('.flash-modal').modal({
    backdrop: 'static',
  });

  $('#show-form-pagamento').click(function() {
      $(this).css('display', 'none');
      $('#form-pagamento').css('display', 'block');
  });

  $('.request-confirmation').on('click', function () {
    const title = $(this).data('title');
    const text = $(this).data('text');
    const url = $(this).data('url');
    const confirmButton = $(this).attr('data-confirmText');
    const cancelButton = $(this).attr('data-cancelText');

    CustomSwal({
      title: title || trans('js-files.conferma-richiesta'),
      text: text || trans('js-files.sicuri-procedere'),
      confirmButtonText: confirmButton || trans('js-files.si-elimina'),
      cancelButtonText: cancelButton || trans('js-files.no-annulla'),
      showCancelButton: true,
    }).then(function (result) {
      if (result.value) {
        location.href = url;
      }
    });
  });

  $('.showhide.btn.btn-black.btn-lg.collapsed')
    .text(trans('common.mostra-ricerca'))
    .click(function () {
      if ($(this).text() == trans('common.mostra-ricerca')) {
        $(this).text(trans('common.nascondi-ricerca'));
      } else {
        $(this).text(trans('common.mostra-ricerca'))
      }
      // $(this).text('Nascondi');
    });
    $('.showhide.btn.btn-primary.btn-lg.collapsed')
    .text(trans('common.mostra-ricerca'))
    .click(function () {
      if ($(this).text() == trans('common.mostra-ricerca')) {
        $(this).text(trans('common.nascondi-ricerca'));
      } else {
        $(this).text(trans('common.mostra-ricerca'))
      }
      // $(this).text('Nascondi');
    });

    // Banners
    const selector = '.swiper-container';
    if(selector) {
        new Swiper(selector, {
            modules: [Navigation, Pagination],
            loop: true,
            rewind: true,
            // allowTouchMove: false,
            // direction: 'vertical',
            autoplay: {
                delay: 3000,
                // disableOnInteraction: false,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                // dynamicBullets: true,
                type: "fraction",
            },
            grabCursor: true,
            height: 300,
            on: {
              init: function () {
                document.querySelector(selector).style.height = `${window.innerHeight * 0.2}px`;
                // startAutoSlide();
              },
            },
        });
    }
    showBanners();
});

function showBanners()
{
  $.ajax({
    url: '/api/v1/banners',
    data: {
      lang: window.location.pathname.split('/').filter(r => r).shift(),
      position: 'homepage',
    },
    method: 'GET',
    success: response => {
        const source = Array.isArray(response.data.banners) ? response.data.banners : [response.data.banners];
      const banners = source
          .map(r => {
              let html = r.text;

              // only text
              const tempElement = document.createElement("div");
              tempElement.innerHTML = html;
              html = `<p style="width: 100%">${tempElement.textContent || tempElement.innerText}</p>`;

              return `<div class="swiper-slide"><div>${html}</div></div>`;
          });

      // console.log(banners)
      if((!banners && !banners.length) || window.location.pathname.split('/').slice(2)[0] !== "") return;

      Swal.fire({
        title: "AVVISI IMPORTANTI",
        html: `<div class="banners">
                <div class="swiper-container">
                     <div class="swiper-wrapper">${banners.join('\n')}</div>
                     <div class="swiper-pagination" style="position: relative; bottom: -5px; font-size: small; color: #a8a8a8; font-weight: 500;"></div>
                     <div class="swiper-button-prev"></div>
                     <div class="swiper-button-next"></div>
                </div>
               </div>`,
        focusCancel: true,
        // nested: true,
        showConfirmButton: false,
        showCancelButton: true,
        cancelButtonText: 'Chiudi',
        customClass: { cancelButton: 'btn btn-primary', content: 'popup-banner', popup: 'overflow-hidden' },
        onOpen: () => {
          const selector = '.swiper-container';
          setTimeout(() => {
            new Swiper(selector, {
              modules: [Navigation, Pagination],
              loop: true,
              rewind: true,
              allowTouchMove: false,
              // direction: 'vertical',
              // autoplay: {
              //   delay: 3000,
              //   // disableOnInteraction: false,
              // },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              pagination: {
                el: '.swiper-pagination',
                // dynamicBullets: true,
                type: "fraction",
              },
              grabCursor: true,
              on: {
                init: function () {
                  document.querySelector('.swiper-container').style.height = `${window.innerHeight * 0.6}px`;
                  startAutoSlide();
                },
              },
            });
            document.querySelector(selector).addEventListener('mouseenter', stopAutoSlide);
            document.querySelector(selector).addEventListener('mouseleave', () => {
                setTimeout(() => startAutoSlide(), 3000);
            });
            // document.querySelector(selector).addEventListener('touchstart', stopAutoSlide);
            // document.querySelector(selector).addEventListener('touchend', startAutoSlide);
          }, 100);
        }
      }).then(() => {
        stopAutoSlide();
      });
    },
    error: response => {
      console.error(response);
      // CustomSwal({
      //   title: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__["default"])('js-files.avviso'),
      //   html: response.responseJSON.errors.join('<br>'),
      //   icon: 'warning',
      //   confirmButtonText: 'Ok'
      // });
    }
  });
}

function startAutoSlide(time = 5000) {
  stopAutoSlide();
  slideInterval = setInterval(() => document.querySelector('.swiper-button-next').click(), time);
}
function stopAutoSlide() {
  clearInterval(slideInterval);
}

(function () {
  'use strict';
  window.addEventListener(
    'load',
    function () {
      // Fetch all the forms we want to apply custom Bootstrap validation styles to
      const forms = document.getElementsByClassName('custom-validation');
      // Loop over them and prevent submission
      Array.prototype.filter.call(forms, function (form) {
        form.addEventListener(
          'submit',
          function (event) {
            if (form.checkValidity() === false) {
              event.preventDefault();
              event.stopPropagation();
            } else {
              const submitInput = form.querySelector('button[type="submit"]');
              if (submitInput) {
                submitInput.classList.add('btn-loading');
              }
            }
            form.classList.add('was-validated');
          },
          false
        );
      });
    },
    false
  );
})();

window.toastr = toastr;
window.CustomSwal = CustomSwal;

window.initGtag = function (config, configId) {
  sendGtagConfig(config, configId);
};

window.trackFormSubmit = trackFormSubmit;

function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

// window.traskContactSedePage = () => {
//   const sede = JSON.parse(document.querySelector('meta[name="sede"]').content);
//   window.trackFormSubmit('contattaci-sede-page', window.location.href);
//   console.log(sede, document.querySelector('meta[name="sede"]'));
//   // return false;
// }
